import { Component, input, output, effect, ViewChild, ElementRef, HostListener } from '@angular/core';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.html',
})
export class ConfirmDialog {
  @ViewChild('confirmBtn') confirmBtn?: ElementRef<HTMLButtonElement>;
  @ViewChild('cancelBtn') cancelBtn?: ElementRef<HTMLButtonElement>;

  visible = input.required<boolean>();
  message = input.required<string>();
  confirmLabel = input<string>('Yes');
  cancelLabel = input<string>('No');

  confirmed = output<void>();
  cancelled = output<void>();

  constructor() {
    effect(() => {
      if (this.visible()) {
        setTimeout(() => this.cancelBtn?.nativeElement.focus(), 0);
      }
    });
  }

  @HostListener('document:keydown.tab', ['$event'])
  handleTab(event: Event): void {
    const kbEvent = event as KeyboardEvent;
    if (!this.visible()) return;
    const confirmElement = this.confirmBtn?.nativeElement;
    const cancelElement = this.cancelBtn?.nativeElement;
    if (kbEvent.shiftKey) {
      if (document.activeElement === confirmElement) {
        kbEvent.preventDefault();
        cancelElement?.focus();
      }
    } else {
      if (document.activeElement === cancelElement) {
        kbEvent.preventDefault();
        confirmElement?.focus();
      }
    }
  }

  @HostListener('document:keydown.escape')
  handleEscape(): void {
    if (this.visible()) {
      this.cancelled.emit();
    }
  }
}
